export default "__VITE_ASSET__Y2jM0Sg1__"